import { ReactElement } from 'react'
import { useRichTextContext } from '../util'
import { Insticator as InsticatorAtom } from '~/components/atoms'

export const Insticator = (): ReactElement => {
	const { category } = useRichTextContext()

	return <InsticatorAtom category={category} />
}
